import { render, staticRenderFns } from "./VisitSummaryTooltip.vue?vue&type=template&id=71c3772c&scoped=true"
import script from "./VisitSummaryTooltip.vue?vue&type=script&lang=ts"
export * from "./VisitSummaryTooltip.vue?vue&type=script&lang=ts"
import style0 from "./VisitSummaryTooltip.vue?vue&type=style&index=0&id=71c3772c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3772c",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/observation/visit/visit-summary/visit-summary-tooltip.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fobservation%2Fvisit%2Fvisit-summary%2FVisitSummaryTooltip.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports